var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 159,
    viewBox: "0 0 160 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.2989 121.571C74.9643 124.866 77.2651 128.705 78.8845 131.703M78.8845 131.703C78.9158 131.761 79.5614 131.228 79.6105 131.185C81.8142 129.274 84.1282 124.6 84.6609 121.912M78.8845 131.703C80.264 113.805 80.0886 93.5213 79.988 73.4886C79.9068 57.3245 79.8743 41.3241 80.7466 26.8731",
    stroke: "url(#paint0_linear_266_435)",
    strokeWidth: 3.43267,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_266_435",
    x1: 58.442,
    y1: 38.5576,
    x2: 101.139,
    y2: 120.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5383B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5383B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.9a72becbe1dc7612f5b4aab1fea74e00.svg";
export { ForwardRef as ReactComponent };